import { globalFetch, post, put } from "foundation/js/api"

export default {
    namespaced: true,
    state: {
        submitting: false
    },
    mutations: {
        SET_IS_SUBMITTING(state, object){
            state.submitting = object
        },
    },
    getters: {

    },
    actions: {
        async createFrivilligjob(context, body){
            const url = `${document.location.origin}`
                + `/${process.env.FRIVILLIGJOB_CREATE}`

            context.commit("SET_IS_SUBMITTING", true)

            const response = await post(url, JSON.stringify(body))

            context.commit("SET_IS_SUBMITTING", false)

            return response
        },
        async getGruppeemner(context, jobId){
            const url = `${document.location.origin}`
                + `/${process.env.FRIVILLIGJOB_GRUPPEEMNER_GET}`.replace('[frivilligjobId]', jobId)

            const method = process.env.GETMETHOD

            const headers = new Headers()
            headers.append("Content-Type", "application/json")

            const init = {
                headers,
                method
            }
            context.commit("SET_IS_SUBMITTING", true)

            return globalFetch(url, init)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                    
                    throw new Error(response.error)
                })
                .finally(() => {
                    context.commit("SET_IS_SUBMITTING", false)
                })
        },
        async updateFrivilligjob(context, body) {
            let url = `${document.location.origin}`
                + `/${process.env.FRIVILLIGJOB_UPDATE}`

            context.commit("SET_IS_SUBMITTING", true)

            const response = await put(url, JSON.stringify(body))

            context.commit("SET_IS_SUBMITTING", false)

            return response
        },
        async removeFrivilligjobImage(context, jobId) {
            const url = `${document.location.origin}/${process.env.FRIVILLIGJOB_IMAGE_DELETE.replace("[frivilligjobId]", jobId)}`

            const method = process.env.DELETEMETHOD

            const headers = new Headers()
            headers.append("Content-Type", "application/json")

            const init = {
                headers,
                method,
            }
            context.commit("SET_IS_SUBMITTING", true)

            return globalFetch(url, init)
                .then((response) => {
                    context.commit("SET_IS_SUBMITTING", false)
                    if (response.ok) {
                        return response;
                    }
                    
                    throw new Error(response.error)
                })
                .finally(() => {
                    context.commit("SET_IS_SUBMITTING", false)
                })
        },
        async submitFrivilligjobImage(context, config) {
            const url = `${document.location.origin}/${process.env.FRIVILLIGJOB_IMAGE_UPDATE.replace("[frivilligjobId]", config.id)}`
            const body = config.body
            
            context.commit("SET_IS_SUBMITTING", true)

            const result = await post(url, body, null, true)

            context.commit("SET_IS_SUBMITTING", false)

            return result
        },
        async deleteFrivilligjob(context, jobId) {
            const url = `${document.location.origin}`
                + `/${process.env.FRIVILLIGJOB_DELETE.replace("[frivilligjobId]", jobId)}`

            const method = process.env.DELETEMETHOD

            const headers = new Headers()
            headers.append("Content-Type", "application/json")

            const init = {
                headers,
                method,
            }
            context.commit("SET_IS_SUBMITTING", true)

            return globalFetch(url, init)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                    
                    throw new Error(response.error)
                })
                .finally(() => {
                    context.commit("SET_IS_SUBMITTING", false)
                })
        }
    }

}
